import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
    return (
        <div style={pageStyle}>
            <nav style={navbarStyle}>
                <Link to="/" style={{textDecoration:'none', color:'#2c3e50'}}><div style={logoStyle}>🐾 VetHelper</div></Link>
                <div style={navLinks}>
                    <Link to="/about" style={navLink}>Hakkımızda</Link>
                    <Link to="/blog" style={navLink}>Blog</Link>
                </div>
            </nav>

            <div style={contentContainer}>
                <h1 style={mainTitle}>Gizlilik Politikası</h1>
                <p style={lastUpdated}>Son Güncelleme: 25 Nisan 2026</p>

                <section style={sectionStyle}>
                    <h2 style={subTitle}>1. Giriş</h2>
                    <p style={textStyle}>
                        <strong>Sanveta Veteriner Hayvan Sağlığı ve Sanayi Ticaret Limited Şirketi</strong> ("Sanveta") olarak, 
                        VetHelper platformu üzerinden kullanıcılarımızın gizliliğine ve kişisel verilerinin korunmasına büyük önem veriyoruz. 
                        Bu politika, hangi verileri topladığımızı, bu verileri nasıl kullandığımızı ve haklarınızı açıklamaktadır.
                    </p>
                </section>

                <section style={sectionStyle}>
                    <h2 style={subTitle}>2. Toplanan Veriler</h2>
                    <h3 style={minorTitle}>A. Kayıt Sırasında Sağlanan Bilgiler</h3>
                    <p style={textStyle}>
                        Platforma kayıt olabilmeniz ve profesyonel modüllere erişebilmeniz için aşağıdaki bilgiler toplanmaktadır:
                    </p>
                    <ul style={listStyle}>
                        <li>İsim ve Soyisim</li>
                        <li>E-posta Adresi</li>
                        <li>Şifre (Şifrelenmiş formatta)</li>
                        <li>Veteriner Hekimlik Beyanı (Sağlık çalışanı doğrulama statüsü)</li>
                    </ul>
                    
                    <h3 style={minorTitle}>B. İstatistiki ve Teknik Veriler</h3>
                    <p style={textStyle}>
                        Kullanıcı deneyimini iyileştirmek ve platform güvenliğini sağlamak amacıyla, çerezler (cookies) aracılığıyla şu bilgiler kaydedilir:
                    </p>
                    <ul style={listStyle}>
                        <li>Konum bilgisi (IP adresi tabanlı şehir/ülke)</li>
                        <li>Cihaz ve işletim sistemi bilgileri</li>
                        <li>Platforma giriş saatleri ve kullanım süreleri</li>
                    </ul>
                </section>

                <section style={sectionStyle}>
                    <h2 style={subTitle}>3. Verilerin Saklanması ve Güvenliği</h2>
                    <p style={textStyle}>
                        Toplanan tüm kişisel veriler, Google tarafından sağlanan yüksek güvenlikli <strong>Firebase</strong> altyapısı üzerinde 
                        bulut ortamında saklanmaktadır. Verileriniz, yetkisiz erişimlere karşı endüstri standardı şifreleme yöntemleriyle korunmaktadır.
                    </p>
                </section>

                <section style={sectionStyle}>
                    <h2 style={subTitle}>4. Veri Paylaşımı</h2>
                    <p style={textStyle}>
                        Sanveta, kullanıcılarına ait kişisel verileri hiçbir koşulda <strong>3. kişilerle veya kurumlarla paylaşmaz</strong>, 
                        ticari amaçla satmaz veya devretmez. Verileriniz yalnızca VetHelper’ın sunduğu hizmetlerin iyileştirilmesi ve 
                        istatistiksel analizler yapılması amacıyla şirket bünyesinde kullanılır.
                    </p>
                </section>

                <section style={sectionStyle}>
                    <h2 style={subTitle}>5. Kullanıcı Hakları ve Veri Silme</h2>
                    <p style={textStyle}>
                        Kullanıcılarımız, istedikleri zaman sistemde kayıtlı olan verilerinin silinmesini talep etme hakkına sahiptir. 
                        Kişisel verilerinizin sistemimizden tamamen kaldırılması için <strong>bivetesor@gmail.com</strong> adresine 
                        kayıtlı e-posta adresinizden bir talep iletmeniz yeterlidir. Talebiniz incelenerek en kısa sürede verileriniz kalıcı olarak silinecektir.
                    </p>
                </section>

                <section style={sectionStyle}>
                    <h2 style={subTitle}>6. İletişim</h2>
                    <p style={textStyle}>
                        Gizlilik politikamızla ilgili her türlü soru ve öneriniz için info@sanveta.com veya bivetesor@gmail.com üzerinden bizimle iletişime geçebilirsiniz.
                    </p>
                </section>
            </div>

            <footer style={footerStyle}>
                <p>© 2026 SANVETA VETERİNER HAYVAN SAĞLIĞI VE SANAYİ TİCARET LİMİTED ŞİRKETİ</p>
                <Link to="/" style={{color: '#3498db', textDecoration: 'none', fontSize: '14px'}}>Ana Sayfaya Dön</Link>
            </footer>
        </div>
    );
}

// --- STİLLER (Mobil ve iOS Safe-Area Uyumlu) ---
const pageStyle = { 
    fontFamily: "'Segoe UI', sans-serif", 
    background: '#f9f9f9', 
    color: '#333', 
    minHeight: '100vh',
    boxSizing: 'border-box',
    width: '100%',
    overflowX: 'hidden'
};

const navbarStyle = { 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    padding: '15px 5%', 
    background: '#fff', 
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    boxSizing: 'border-box',
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    paddingTop: 'max(15px, env(safe-area-inset-top))' // iOS Çentik Koruması
};

const logoStyle = { fontSize: '20px', fontWeight: 'bold' };
const navLinks = { display: 'flex', gap: '15px' };
const navLink = { textDecoration: 'none', color: '#7f8c8d', fontSize: '14px', fontWeight: '600' };

const contentContainer = { 
    maxWidth: '800px', 
    margin: '30px auto', 
    padding: '30px 20px', 
    background: '#fff', 
    borderRadius: '15px', 
    boxShadow: '0 5px 20px rgba(0,0,0,0.05)',
    boxSizing: 'border-box',
    width: '92%'
};

const mainTitle = { fontSize: 'clamp(24px, 4vw, 32px)', borderBottom: '3px solid #3498db', paddingBottom: '10px', color: '#2c3e50', wordBreak: 'break-word' };
const lastUpdated = { fontSize: '13px', color: '#95a5a5', marginBottom: '30px' };
const sectionStyle = { marginBottom: '30px', boxSizing: 'border-box' };
const subTitle = { fontSize: '20px', color: '#2c3e50', marginBottom: '15px', wordBreak: 'break-word' };
const minorTitle = { fontSize: '16px', fontWeight: 'bold', marginTop: '15px', wordBreak: 'break-word' };
const textStyle = { fontSize: '15px', lineHeight: '1.7', color: '#555', wordBreak: 'break-word' };
const listStyle = { marginTop: '10px', paddingLeft: '20px', color: '#555', fontSize: '15px', lineHeight: '1.8', wordBreak: 'break-word' };

const footerStyle = { 
    textAlign: 'center', 
    padding: '40px 20px', 
    background: '#1a252f', 
    color: '#fff',
    boxSizing: 'border-box',
    width: '100%',
    paddingBottom: 'max(40px, env(safe-area-inset-bottom))' // iOS Alt Çubuk Koruması
};